import { render, staticRenderFns } from "./ResumenPaciente.vue?vue&type=template&id=cdc3b320&scoped=true&lang=pug&"
import script from "./ResumenPaciente.vue?vue&type=script&lang=js&"
export * from "./ResumenPaciente.vue?vue&type=script&lang=js&"
import style0 from "./ResumenPaciente.vue?vue&type=style&index=0&id=cdc3b320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc3b320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
